/**
 * ****************************************************************************
 * @description     :   Route for gr module
 * @created at      :   2023/08/29
 * @created by      :   ANS897 – hieunm@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const gr0390r = () => import('@/views/gr/gr0390r');
const gr0400r = () => import('@/views/gr/gr0400r');
const gr0440r = () => import('@/views/gr/gr0440r');
const gr0450r = () => import('@/views/gr/gr0450r');
const gr0420r = () => import('@/views/gr/gr0420r');
const gr0500r = () => import('@/views/gr/gr0500r');
const gr0590r = () => import('@/views/gr/gr0590r');
const gr0510i = () => import('@/views/gr/gr0510i');
const gr0460i = () => import('@/views/gr/gr0460i');
/**
 * Defined Router
 */
const resource = 'gr';
export default [
    {
        path: `/${resource}/gr0390r`,
        name: 'Gr0390r',
        component: gr0390r,
        meta: {
            title: '就業日報'
        }
    },
    {
        path: `/${resource}/gr0400r`,
        name: 'Gr0400r',
        component: gr0400r,
        meta: {
            title: '集計レポート'
        }
    },
    {
        path: `/${resource}/gr0440r`,
        name: 'Gr0440r',
        component: gr0440r,
        meta: {
            title: '就業月報'
        }
    },
    {
        path: `/${resource}/gr0450r`,
        name: 'Gr0450r',
        component: gr0450r,
        meta: {
            title: '集計データダウンロード'
        }
    },
    {
        path: `/${resource}/gr0420r`,
        name: 'Gr0420r',
        component: gr0420r,
        meta: {
            title: '打刻漏れ一覧'
        }
    },
    {
        path: `/${resource}/gr0500r`,
        name: 'Gr0500r',
        component: gr0500r,
        meta: {
            title: '就業年報'
        }
    },
    {
        path: `/${resource}/gr0590r`,
        name: 'Gr0590r',
        component: gr0590r,
        meta: {
            title: '実態乖離リスト'
        }
    },
    {
        path: `/${resource}/gr0510i`,
        name: 'Gr0510i',
        component: gr0510i,
        meta: {
            title: '36協定順守状況一覧'
        }
    },
    {
        path: `/${resource}/gr0460i`,
        name: 'Gr0460i',
        component: gr0460i,
        meta: {
            title: '年次有給休暇管理台帳'
        }
    }
];
